import { render } from "./ImageCarousel.vue?vue&type=template&id=829c9e4a&scoped=true"
import script from "./ImageCarousel.vue?vue&type=script&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&lang=js"

import "./ImageCarousel.vue?vue&type=style&index=0&id=829c9e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829c9e4a"]])

export default __exports__